import Layout from "../../components/layOutWrapper/layOutWrapper";
import VehicleForm from "../../components/vehicles/addVehicleForm";

export default function ModifyVehicleFormView (vehicleData: any) {
    return (
        <>
            <Layout children={<VehicleForm vehicleData={vehicleData}/>} sectionTitle="Modificar vehículo"/>
        </>
    )
}